import { useTranslation } from 'next-i18next';

import React, { useState } from 'react';

import { Box, Button, useSlotRecipe } from '@chakra-ui/react';

import { MarkdownRenderer } from '@app/components/atoms/markdown-renderer';

import { ListingDescriptionProps } from './listing-description.props';

export const ListingDescription = ({
    description,
    previewParagraphsCount = 2,
}: ListingDescriptionProps) => {
    const { t } = useTranslation('listing', { keyPrefix: 'description' });
    const [open, setOpen] = useState(true);
    const recipe = useSlotRecipe({ key: 'listingLayout' });
    const styles = recipe({});
    const paragraphs = description.split('\n').filter(p => p.trim() !== '');
    const hasMore = paragraphs.length > previewParagraphsCount;
    const preview = paragraphs.slice(0, previewParagraphsCount).join('\n');

    return (
        <Box css={styles.description}>
            <MarkdownRenderer content={open || !hasMore ? description : preview} />
            {hasMore && (
                <Button
                    css={styles.descriptionButton}
                    variant="link"
                    size="sm"
                    onClick={() => setOpen(value => !value)}
                >
                    {t(open ? 'collapse' : 'expand')}
                </Button>
            )}
        </Box>
    );
};
